import ServicePage from "../ServicePage";
import { servicesData } from "@/mocks/services";

export default function DpePage() {
  return <ServicePage data={servicesData.dpe} />;
}
